import React, { useEffect } from "react";
import { Container, Card, Image } from "react-bootstrap";
import { BsStarFill, BsStarHalf, BsStar } from "react-icons/bs";

import AOS from "aos";
import "aos/dist/aos.css";

const passengerfeedback = [
  {
    name: "Amit Sharma",
    role: "Family Traveller, Delhi",
    image: "https://randomuser.me/api/portraits/men/45.jpg",
    text: "Our Andaman trip was perfectly planned. From airport pickup to island hopping, everything was smooth and well organized. Highly recommended for family vacations.",
    rating: 4.5,
  },
  {
    name: "Priya Nair",
    role: "Solo Traveller, Kochi",
    image: "https://randomuser.me/api/portraits/women/65.jpg",
    text: "Amazing experience! The team was very supportive and responsive. The beaches, resorts, and activities exceeded my expectations. Truly memorable.",
    rating: 5,
  },
  {
    name: "Rohit Verma",
    role: "Honeymoon Traveller, Jaipur",
    image: "https://randomuser.me/api/portraits/men/52.jpg",
    text: "We booked our honeymoon package and it was absolutely worth it. Beautiful locations, great hotels, and flawless coordination throughout the trip.",
    rating: 4,
  },
  {
    name: "Sneha Patel",
    role: "Group Traveller, Ahmedabad",
    image: "https://randomuser.me/api/portraits/women/48.jpg",
    text: "Traveling with friends was super fun and stress-free. The itinerary was well balanced and customized according to our preferences. Loved the service!",
    rating: 4.5,
  },
];

export default function Travelfeedback() {
  const looppassengerfeedback = [...passengerfeedback, ...passengerfeedback];

  useEffect(() => {
    AOS.init({ duration: 1000, once: true, easing: "ease-out-cubic" });
  }, []);

  return (
    <section className="travelfeedback-section py-10 container-fluid">
      <Container>
       
        <div className="text-center mb-4" data-aos="fade-up">
          <h2 className="new-font fw-semibold">Clients Feedback About Us</h2>
          <h2 className="fw-bold display-6" style={{ color: "black" }}>
            See Those Lovely Words From Clients
          </h2>
         
        </div>

    
        <div className="travelfeedback-slider" data-aos="fade-up" data-aos-delay="200">
          <div className="slider-track">
            {looppassengerfeedback.map((t, i) => (
              <div
                className="slide"
                key={i}
                data-aos="zoom-in"
                data-aos-delay={i * 120} // stagger effect
              >
                <Card className="travelfeedback-card shadow-sm border-0">
                  <Card.Body>
                    <div className="d-flex justify-content-between">
                      
                      {/* Profile */}
                      <div className="d-flex align-items-center mb-3">
                       
                        <div>
                          <h6 className="mb-0 fw-bold" style={{ color: "black", fontSize: "18px" }}>
                            {t.name}
                          </h6>
                          <small className="text-muted" style={{ fontSize: "14px" }}>
                            {t.role}
                          </small>
                        </div>
                      </div>

                      {/* Quote Icon */}
                      <div className="quote-icon">
                        <span>&#10077;</span>
                      </div>
                    </div>

                    {/* Text */}
                    <p className="travelfeedback-text mt-2">{t.text}</p>

                    {/* Rating */}
                    <div className="star-rating mt-3">
                      {[...Array(5)].map((_, index) => {
                        if (index + 1 <= Math.floor(t.rating)) {
                          return <BsStarFill key={index} className="star" />;
                        } else if (index + 0.5 === t.rating) {
                          return <BsStarHalf key={index} className="star" />;
                        } else {
                          return <BsStar key={index} className="star" />;
                        }
                      })}
                    </div>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </div>
        </div>

      </Container>
    </section>
  );
}
